import { render, staticRenderFns } from "./MagazinCard.vue?vue&type=template&id=60e837ab&scoped=true&"
import script from "./MagazinCard.vue?vue&type=script&lang=js&"
export * from "./MagazinCard.vue?vue&type=script&lang=js&"
import style0 from "./MagazinCard.vue?vue&type=style&index=0&id=60e837ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e837ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VChip,VImg})
